module.exports = __webpack_public_path__ + "1a577984ac279fcda72d4a75e461de66.svg";